import { render, staticRenderFns } from "./ProfileArticles.vue?vue&type=template&id=938c279c&"
import script from "./ProfileArticles.vue?vue&type=script&lang=js&"
export * from "./ProfileArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProfileArticles.vue"
export default component.exports